import { useCallback, useMemo } from 'react';

import { NotificationSound } from './NotificationSound.type';

export const useNotificationSound: NotificationSound = () => {
  const sound = useMemo(() => new Audio('/ding.mp3'), []);

  const verifyPermissions = useCallback(() => {
    return Notification.permission === 'granted';
  }, []);

  const playSound = useCallback(async () => {
    try {
      if (verifyPermissions()) {
        await sound?.play();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }, [sound, verifyPermissions]);

  return { playSound };
};
